/* eslint-disable arrow-body-style */
/* eslint-disable no-useless-constructor */

/**
 *  class for handling leaderboards on social platforms
 */
export class OMT_PlatformLeaderboards {
  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * Post a session score for a social tournament
   * @param {string} leaderboardName
   * @param {number} totalScore
   * @param {number} sessionScore
   */
  postTournamentScore(leaderboardName, totalScore, sessionScore) {
    FBInstant.getLeaderboardAsync(leaderboardName)
      .then((leaderboard) => {
        return leaderboard.setScoreAsync(totalScore);
      });
    FBInstant.postSessionScore(sessionScore);
    OMT.utils.stylizedLog(`OMT_PlatformLeaderboards: Posted to leaderboard ${leaderboardName}.`);
  }
}
